import { useContext } from "react";
import { ProfileContext, ProfileContextPayload } from "../../Context/ProfileDetailsContext";
import ExtractionStepContainer from "./ExtractionSteps/ExtractionStepContainer";
import FileSelectionComponent from "./FileSelectionComponent";

const PdfExtractionHandler = () => {
    const { flagImportBtnClicked } = useContext(ProfileContext) as ProfileContextPayload;
    return (
        <>
            {
                flagImportBtnClicked
                    ?
                    <ExtractionStepContainer />
                    :
                    <FileSelectionComponent />
            }
        </>
    )
}

export default PdfExtractionHandler
